/**
 * LinkingModeSwitchDialog
 * Confirmation dialog shown when switching between CATEGORY ↔ EQUIPMENT mode.
 * Warns the user that existing selections will be lost.
 */

import { Button } from '@/components/ui';
import { useTranslation } from '@kgc/i18n';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@kgc/ui';

interface Props {
  open: boolean;
  itemCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export function LinkingModeSwitchDialog({ open, itemCount, onConfirm, onCancel }: Props) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={o => !o && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('packages.scope.switchConfirmTitle')}</DialogTitle>
          <DialogDescription>
            {t('packages.scope.switchConfirmBody', { count: itemCount })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="ghost" onClick={onCancel}>
            {t('packages.scope.switchConfirmCancel')}
          </Button>
          <Button onClick={onConfirm}>{t('packages.scope.switchConfirmOk')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
